export enum CommonParams {
  SearchQuery = "q",
  Filters = "filters",
  ActiveFields = "fields",
  SortBy = "sort_by",
}
